import Vue from 'vue';
import Glossary from "../vue/Glossary.vue";

document.addEventListener("DOMContentLoaded", function() {
    if(document.querySelector('.vue-glossary')) {
        initGlossary();
    }
});

window.addEventListener("Pageeditor:insert", function() {
    if(document.querySelector('.vue-glossary')) {
        initGlossary();
    }
});

window.addEventListener("Pageeditor:change", function() {
    if(document.querySelector('.vue-glossary')) {
        initGlossary();
    }
});

function initGlossary()
{
    new Vue({
        name: 'GlossaryElement',
        el: '.vue-glossary',
        data: () => ({
        }),
        components: {
           Glossary
        },
        computed: {
        },
        methods: {
        },
        mounted()
        {
        },
    });
}